module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-R-37.c0f2d08b.png";